import { Component, Input, Injector, OnInit, OnDestroy } from '@angular/core';
import { ListItem } from 'src/app/models/app/Interfaces/list-item';
import { QuoteStepBase } from 'src/app/pages/quote-step-base/quote-step-base';
import * as strings from './xsell-renewal-modal.component.string';
import { GtmEventIds } from 'src/app/constants/gtm-event-ids';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleTagEvents } from 'src/app/models/app/Interfaces/googleTagEvent';
import { WsNewBusinessLeadInfo } from 'src/app/models/dto/wsNewBusinessLeadInfo';
import { DateService } from 'src/app/services/dates/date.service';
import { LeadService } from 'src/app/services/leads/lead.service';
import { MotorQuoteStateService } from 'src/app/services/motor-quote-state/motor-quote-state.service';
import { environment } from 'src/environments/environment';
import { XsellService } from 'src/app/services/xsell-service/xsell.service';
import { XSellForm } from 'src/app/models/app/Interfaces/quote-form-interfaces';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { DropdownEventDirective } from '../../../directives/dropdown-event.directive';
import { NgClass } from '@angular/common';
import { QuestionDropdownComponent } from '../../question-dropdown/question-dropdown.component';
import { QuestionButtonsComponent } from '../../question-buttons/question-buttons.component';

export class XSellConfirmModalActionsVm {
    customAction?: (val: string, isStarted: boolean) => any ;
    inputs: any ;
}

@Component({
    selector: 'app-xsell-renewal-modal',
    templateUrl: './xsell-renewal-modal.component.html',
    styleUrl: './xsell-renewal-modal.component.scss',
    imports: [BaseModalComponent, DropdownEventDirective, FormsModule, ReactiveFormsModule, QuestionDropdownComponent, NgClass, QuestionButtonsComponent]
})

export class XSellRenewalModalComponent extends QuoteStepBase implements OnInit, OnDestroy {
    @Input() inProcessModal: boolean = false;
    @Input() hasRenewalMonth: boolean = false;
    @Input() set inputs(value: XSellConfirmModalActionsVm) {
        this.modalActions = value;
    }

    public gtmEventIds = GtmEventIds;
    public s = strings;
    public monthsList: Array<ListItem> = [];
    public modalActions: XSellConfirmModalActionsVm = new XSellConfirmModalActionsVm();
    public selectedRenewalMonth: string | undefined;
    public xSellLink: string = '';
    public monthSelected: boolean = false;

    public disableQuoteNow = false;

    public isGetStarted: boolean = false;

    public xSellForm: FormGroup<XSellForm> = new FormGroup({
        xSellMonths: new FormControl({ value: null, disabled: false }, { updateOn: 'change' }),
    }, {
        validators: []
    });

    public renewalMonthSelected: boolean = this.xSellForm.get('xSellMonths')?.value;
    public hasRenewalMonthSelected: boolean = this.renewalMonthSelected;

    public xSellOptionForm: FormGroup;
    public xSellOptionsList = [
        { value: this.s.doQuickQuestion, code: 'do-quick-question', gtmEventId: GtmEventIds.xSellQuickQuestionsPopup },
        { value: this.s.doQuoteNow, code: 'do-quote', gtmEventId: GtmEventIds.xSellDoQuoteNowPopup }
    ];

    constructor(public override injector: Injector,
        private readonly dateService: DateService,
        private readonly leadService: LeadService,
        private readonly motorQuoteService: MotorQuoteStateService,
        private readonly formBuilder: FormBuilder,
        private readonly xsellService: XsellService) {
        super(injector);
        this.xSellOptionForm = this.formBuilder.group(
            {
                xSellJourneyOption: this.formBuilder.control({ value: null, disabled: false }, { validators: [Validators.required], updateOn: 'change' }),
            }
        );
    }

    public ngOnInit(): void {
        this.monthsList = this.listService.getMonthsList();
    }

    public ngOnDestroy() {

        if (!this.isGetStarted) {
            this.triggerGtmEvent('pop_up', 'close', '', 'xsell_choose_month_popup', 'close');
        }

    }

    public async closeXSellModal() {
        if (this.xSellLink) {
            if (this.modalActions?.customAction) {
                await this.modalActions.customAction(this.xSellLink, this.isGetStarted);
            }
        }
        this.modalService.dismissAll();
    }

    public handleMonthSelected(renewalMonth: number) {
        this.selectedRenewalMonth = renewalMonth.toString();
    }

    public handleContinueSelected(event: any) {
        if (this.selectedRenewalMonth) {
            this.triggerGtmEvent('button_click', event.currentTarget?.id);
            this.hasRenewalMonth = true;
            let renewalDate = this.dateService.getRenewalDateForRenewalMonth(this.selectedRenewalMonth);
            const body: WsNewBusinessLeadInfo = {
                policyId: this.modalActions.inputs,
                renewalDate: renewalDate,
                isQuote: false
            }
            this.monthSelected = true;
            this.disableQuoteNow = true;
            this.leadService.createLead(body)
                .subscribe(xsellLinkValue => {
                    this.xSellLink = xsellLinkValue;
                    this.disableQuoteNow = false;
                    this.motorQuoteService.setPopupRenewalMonthSelected(true);
                    this.xsellService.setXsellLink(this.xSellLink);
                    if (this.modalActions?.customAction) {
                        this.modalActions.customAction(this.xSellLink, this.isGetStarted);
                    }
                });
        } else {
            this.closeXSellModal();
        }
    }

    public onGetStarted(event: Event) {
        const targetElement = (event.target as HTMLElement).closest('button');
        const selectedxSell = this.xSellOptionForm.get("xSellJourneyOption")?.value;
        let xSellUrl;
        if (this.xSellLink.length > 0 && selectedxSell == 'do-quote') {
            this.isGetStarted = true;
            window.open(
                this.xSellLink,
                "_blank",
                'noopener,noreferrer'
            );
            this.closeXSellModal();
            xSellUrl = this.xSellLink;
        } else if (selectedxSell == 'do-quick-question') {
            this.isGetStarted = true;
            const val = decodeURIComponent(this.xSellLink);
            const leadHash = val?.length ? val.split("lead=")[1] : "";
            const url = environment.houseHoldLandingPath + '/#/quick-questions/page-one?lead=' + decodeURIComponent(leadHash);
            xSellUrl = url;
            window.open(
                url,
                "_blank",
                'noopener,noreferrer'
            );
            this.closeXSellModal();
        }
        this.triggerGtmEvent('link_click', GtmEventIds.xsellGetStartedPopup, xSellUrl, targetElement?.id);
    }

    public openMotorPolicyLink(policyLink: string, event: Event) {
        const targetElement = (event.target as HTMLElement).closest('a');
        window.open(
            policyLink,
            '_blank',
            'menubar=0,resizable=1,scrollbars=1,status=0,titlebar=0,toolbar=0,width=650,height=500,noopener,noreferrer'
        );
        this.triggerGtmEvent('link_click', GtmEventIds.rsaMotorPolicy, policyLink, targetElement?.id);
    }

    public triggerGtmEvent(event_name: string, gtmEventId: string, event_link_url: string = '', html_id = '', action: string = 'click') {
        let gtmOptions: GoogleTagEvents = {
            event: event_name,
            action: action,
            html_id: html_id,
            name: gtmEventId,
        }
        if (event_link_url.length > 0) {
            gtmOptions.link_url = event_link_url;
        }
        this.googleTagManagerService.trackAction(gtmOptions);
    }
}
